import { render, staticRenderFns } from "./ngo-admin-add.vue?vue&type=template&id=125fbbc1&scoped=true&"
import script from "./ngo-admin-add.vue?vue&type=script&lang=js&"
export * from "./ngo-admin-add.vue?vue&type=script&lang=js&"
import style0 from "./ngo-admin-add.vue?vue&type=style&index=0&id=125fbbc1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125fbbc1",
  null
  
)

export default component.exports